import { enqueueSnackbar } from "notistack";
import { useApiClient } from "../../../api";

export const useImageAnswerSubmission = ({
  user,
  token,
  assignmentQuestion,
}) => {
  const ApiClient = useApiClient();

  const submitImages = async ({ images, identifier }) => {
    try {
      const response = await ApiClient.assignment.submitUploadedImages({
        user,
        assignmentQuestion,
        token,
        images,
        student: identifier.id,
      });

      if (response.success) {
        enqueueSnackbar("Successfully submitted, submit another?", {
          variant: "success",
          autoHideDuration: 3000,
        });

        return {
          success: true,
          students: response.students,
          answers: response.answers,
        };
      }

      enqueueSnackbar(response.message, {
        variant: "error",
        autoHideDuration: 3000,
      });

      return { success: false };
    } catch (error) {
      console.error("Failed to submit handwritten images", {
        assignmentQuestion,
        student: identifier?.id,
        error,
      });
      enqueueSnackbar("Error submitting, please try again", {
        variant: "error",
        autoHideDuration: 3000,
      });

      return { success: false };
    }
  };

  return { submitImages };
};
